import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import {
  baseRteQuillEditorMaxHeightVar,
  baseRteQuillFullscreenHeightVar,
} from '#/components/BaseRte/BaseRte.styled';
import { Modal, getModalBackgroundImage } from '#/modals/Modal';
import { defaultDialogBorderRadius, modalBaseInset } from '#/modals/ModalBase';
import { colors, cssBreakpoints, spacing } from '#/theme/theme';

const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

// Do not change the Modal itself, this is used only to decouple Modal from
// Quill
const ListingRteModal = styled(Modal)`
  ${baseRteQuillEditorMaxHeightVar}: 100%;
`;

const ListingRteDialog = styled.div`
  outline: 0;
  width: 100%;
  background-color: white;

  box-shadow: 0 3px 8px 0 rgb(0 0 0 / 40%);
  text-align: left;
  box-sizing: border-box;
  max-width: 768px;
  margin: auto;
  cursor: default;
  color: ${colors.mediumContentGrey};
  line-height: 1.5;

  display: grid;
  place-content: stretch;
  position: fixed;
  inset: 0;
  padding: ${spacing[24]} ${spacing[16]} ${spacing[16]};

  height: 100dvh;

  ${baseRteQuillFullscreenHeightVar}: calc(100dvh - 40px);

  @media (min-width: ${cssBreakpoints.smUp}) {
    ${getModalBackgroundImage()}
    height: calc(100dvh - ${modalBaseInset} * 4);

    ${baseRteQuillFullscreenHeightVar}: calc(100dvh - 106px);

    border-radius: ${defaultDialogBorderRadius};
    position: unset;
  }
`;

export function ListingRteFullscreenModal({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <ListingRteModal
      isCloseButtonVisible={false}
      wide
      render={() => (
        // NOTE: TabContainer exists only to allow for focus trap support which
        // requires at least one focusable element. That focusable element is
        // available in the Quill editor. However, the Quill editor is not available
        // on React component mount.
        <ListingRteDialog>
          <TabContainer tabIndex={0}>{children}</TabContainer>
        </ListingRteDialog>
      )}
    />
  );
}
